var _polygon, _polygon2, _polygon3, _polygon4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebpack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "24,4 7,14 7,34 24,44 41,34 41,14"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0277bd",
    points: "23.5,24.5 23.5,33.5 15,29 15,19.5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0277bd",
    points: "24.5,24.5 24.5,33.5 33,29 33,19.5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0277bd",
    points: "24,23.5 15.5,18.5 24,14 32.5,18.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#81d4fa",
    points: "23.5,7 23.5,13 14.5,18 9.5,15"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#81d4fa",
    points: "23.5,41 23.5,35 14.5,30 9.5,33"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#81d4fa",
    points: "14,19 9,16 9,32 14,29"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#81d4fa",
    points: "24.5,7 24.5,13 33.5,18 38.5,15"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#81d4fa",
    points: "24.5,41 24.5,35 33.5,30 38.5,33"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#81d4fa",
    points: "34,19 39,16 39,32 34,29"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpack);
export default __webpack_public_path__ + "static/media/webpack.0a4000cb454d19439c50ae635800fd27.svg";
export { ForwardRef as ReactComponent };